export default __webpack_public_path__ + "static/media/Registration.7ada9fc4.png";